// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"17":"ddf3ab50","260":"23d02a55","385":"fda793c9","927":"18d28fa4"}[chunkId] + ".chunk.css";
};